
export default {
  name: 'AboutProduct',
}
